const caseClosed = () => import("@/views/myCase/caseClosed.vue");
const AppPeace = () =>
    import('@/layout/AppPeace.vue');
const caseInHand = ()=>import ("@/views/myCase/caseInHand.vue")
export default {
  path: "/",
  component: AppPeace,
 
  children: [
  
    {
      path: "/caseClosed",
      name: "caseClosed",
      component: caseClosed,
    },
    {
        path: "/caseInHand",
        name: "caseInHand",
        component: caseInHand,
      },
  
  ],
};
